import * as React from 'react';

var defaultValue = {
  direction: 'horizontal'
};
var TimelineContext = /*#__PURE__*/React.createContext(defaultValue);
var useTimelineContext = function useTimelineContext() {
  var context = React.useContext(TimelineContext);
  return context;
};
var TimelineContextProvider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? defaultValue : _ref$value;
  return /*#__PURE__*/React.createElement(TimelineContext.Provider, {
    value: value
  }, children);
});
TimelineContextProvider.displayName = 'TimelineContextProvider';

export { TimelineContextProvider, useTimelineContext };
//# sourceMappingURL=TimelineContext.js.map
